import { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

const defaultState = {
  open: false,
  message: "",
  severity: "info",
};

const OfflineSyncIndicator = () => {
  const [state, setState] = useState(defaultState);

  useEffect(() => {
    if (typeof window === "undefined") {
      return () => {};
    }

    const handleQueued = (event) => {
      const method = event?.detail?.method ? event.detail.method.toUpperCase() : "REQUEST";
      setState({
        open: true,
        severity: "info",
        message: `${method} saved for offline sync. We'll retry when you're online.`,
      });
    };

    const handleSynced = (event) => {
      const remaining = event?.detail?.remaining ?? 0;
      setState({
        open: true,
        severity: remaining > 0 ? "warning" : "success",
        message:
          remaining > 0
            ? `Some offline changes are still pending. We'll keep trying automatically.`
            : "Offline changes synced successfully.",
      });
    };

    window.addEventListener("omnio:offline-queued", handleQueued);
    window.addEventListener("omnio:offline-sync-complete", handleSynced);

    return () => {
      window.removeEventListener("omnio:offline-queued", handleQueued);
      window.removeEventListener("omnio:offline-sync-complete", handleSynced);
    };
  }, []);

  const handleClose = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setState((current) => ({ ...current, open: false }));
  };

  return (
    <Snackbar
      open={state.open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        onClose={handleClose}
        severity={state.severity}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {state.message}
      </Alert>
    </Snackbar>
  );
};

export default OfflineSyncIndicator;
